export const siteName = '韩漫网';
export const siteSlogan = '全网韩漫一站畅读，热门完结随时追更';

export const navLinks = [
  { label: '热门话题', href: '#topics' },
  { label: '平台特色', href: '#features' },
  { label: '移动入口', href: '#app' },
  { label: '联系我们', href: '#contact' },
  { label: '分类索引', href: '#index' },
];

export const heroStats = [
  { label: '收录韩漫', value: '12,000+' },
  { label: '每日更新', value: '200+话' },
  { label: '完结作品', value: '3,500+部' },
];

export const updates = [
  { date: '2026-07-29', title: '《剑尊归来》第178话更新，大战一触即发', tag: '热血' },
  { date: '2026-07-29', title: '《我独自升级》番外篇第三章上线', tag: '奇幻' },
  { date: '2026-07-28', title: '《全知读者视角》第215话：新副本开启', tag: '穿越' },
  { date: '2026-07-28', title: '《伯爵家的废物》第92话甜蜜更新', tag: '恋爱' },
  { date: '2026-07-27', title: '《SSS级猎人》第143话Boss战高潮', tag: '动作' },
  { date: '2026-07-27', title: '《反派大小姐》第67话剧情大反转', tag: '宫廷' },
  { date: '2026-07-26', title: '《重生之都市修仙》第89话突破境界', tag: '修仙' },
];

export const contactInfo = {
  title: '投稿与合作',
  description: '欢迎漫画作者、翻译组与内容创作者联系我们。无论是作品推荐、汉化合作还是广告投放，韩漫网期待与您携手共赢。',
  email: 'contact@hanman.example.com',
  qq: '1234567890',
};

export const topics = [
  { name: '系统流', hot: true, count: '3.2万讨论' },
  { name: '重生穿越', hot: true, count: '5.8万讨论' },
  { name: '恋爱甜漫', hot: true, count: '4.1万讨论' },
  { name: '热血格斗', hot: false, count: '2.7万讨论' },
  { name: '宫廷权谋', hot: true, count: '3.5万讨论' },
  { name: '奇幻冒险', hot: false, count: '2.1万讨论' },
  { name: '都市言情', hot: false, count: '1.9万讨论' },
  { name: '修仙玄幻', hot: false, count: '2.4万讨论' },
  { name: '悬疑推理', hot: true, count: '1.6万讨论' },
];

export const features = [
  {
    icon: 'ri-smartphone-line',
    title: '下拉式畅读',
    desc: '独创下拉阅读模式，无缝衔接每一话，无需翻页等待，沉浸式韩漫阅读体验，追更从未如此流畅。',
  },
  {
    icon: 'ri-book-open-line',
    title: '海量全集',
    desc: '收录超过一万两千部韩漫作品，热门连载与完结经典一网打尽，支持韩漫在线免费阅读。',
  },
  {
    icon: 'ri-fire-line',
    title: '实时更新',
    desc: '每日同步更新200+话最新内容，第一时间推送热门韩漫新章节，再也不用担心错过更新。',
  },
];

export const ranking = [
  {
    rank: 1,
    title: '剑尊归来',
    tag: '热血/武侠',
    desc: '涅槃重生，一剑封神，千万读者追更的现象级韩漫巨作。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20style%20martial%20arts%20character%20with%20sword%2C%20dramatic%20pose%20warm%20colors%2C%20clean%20simple%20background%2C%20professional%20digital%20illustration&width=160&height=160&seq=ranking-01&orientation=squarish',
  },
  {
    rank: 2,
    title: '我独自升级',
    tag: '奇幻/系统',
    desc: '从最弱到最强，猎人征程燃爆全场，完结神作持续霸榜。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20style%20hunter%20fantasy%20character%20with%20dark%20aura%2C%20powerful%20stance%20warm%20amber%20tones%2C%20clean%20background%2C%20modern%20digital%20illustration&width=160&height=160&seq=ranking-02&orientation=squarish',
  },
  {
    rank: 3,
    title: '全知读者视角',
    tag: '穿越/生存',
    desc: '小说变成现实，唯一知晓结局的人如何改写命运。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20style%20mysterious%20protagonist%20holding%20book%2C%20dramatic%20lighting%20warm%20coral%20tone%2C%20clean%20simple%20background%2C%20professional%20digital%20illustration&width=160&height=160&seq=ranking-03&orientation=squarish',
  },
  {
    rank: 4,
    title: '伯爵家的废物',
    tag: '恋爱/宫廷',
    desc: '甜蜜与阴谋交织，落魄千金的逆袭之路令人心动。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20style%20elegant%20noblewoman%20character%20in%20vintage%20dress%2C%20soft%20romantic%20warm%20lighting%2C%20clean%20simple%20background%2C%20professional%20digital%20illustration&width=160&height=160&seq=ranking-04&orientation=squarish',
  },
  {
    rank: 5,
    title: 'SSS级猎人',
    tag: '动作/奇幻',
    desc: '极限狩猎，SSS级猎人的传说正在书写，战斗场面炸裂。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20style%20action%20hunter%20character%20with%20weapon%2C%20dynamic%20pose%20warm%20orange%20tones%2C%20clean%20simple%20background%2C%20professional%20digital%20illustration&width=160&height=160&seq=ranking-05&orientation=squarish',
  },
];

export const cards = [
  {
    title: '本月新番速递',
    tag: '新作',
    desc: '七月新上架韩漫精选合集，从热血战斗到甜蜜恋爱，新作质量拉满，抢先入坑不踩雷。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20collage%20of%20new%20comic%20releases%2C%20vibrant%20colorful%20warm%20gradient%2C%20excitement%20and%20fresh%20energy%2C%20professional%20layout%20design%20with%20clean%20background&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '完结神作补完计划',
    tag: '完结',
    desc: '一口气读完的经典完结韩漫大推荐，部部高分，错过就太可惜了，周末补番首选。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20completed%20masterpiece%20collection%2C%20warm%20golden%20tones%2C%20classic%20elegant%20feel%2C%20sophisticated%20layout%20with%20soft%20gradient%20background&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '冷门佳作发掘',
    tag: '冷门',
    desc: '评分高却鲜为人知的宝藏韩漫，剧情深度与画风俱佳，发现属于你的小众神作。',
    image: 'https://readdy.ai/api/search-image?query=Hidden%20gem%20Korean%20webtoon%20discovery%2C%20soft%20mysterious%20warm%20lighting%2C%20treasure%20hunting%20vibe%2C%20clean%20elegant%20layout%20with%20subtle%20texture%20background&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: '恋爱漫画特辑',
    tag: '恋爱',
    desc: '甜到牙疼的韩漫恋爱合集，霸道总裁、校园初恋、契约婚姻，满足你的少女心。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20collection%2C%20soft%20pink%20and%20warm%20coral%20tones%2C%20sweet%20dreamy%20atmosphere%2C%20gentle%20layout%20with%20floral%20elements%20and%20clean%20background&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '热血战斗图鉴',
    tag: '热血',
    desc: '拳拳到肉的硬核格斗韩漫，打斗分镜炸裂，剧情燃到飞起，热血沸腾不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20battle%20compilation%2C%20fiery%20warm%20orange%20and%20red%20tones%2C%20dynamic%20energy%2C%20bold%20layout%20with%20dramatic%20composition%20and%20clean%20background&width=600&height=400&seq=card-05&orientation=landscape',
  },
];

export const comments = [
  {
    avatar: 'R',
    name: '漫迷小王',
    time: '2小时前',
    content: '韩漫网真的太方便了，下拉式阅读追更体验超棒！剑尊归来每周必追，推荐给所有朋友了。',
    likes: 128,
  },
  {
    avatar: 'M',
    name: '甜甜圈',
    time: '5小时前',
    content: '在这里找到了好多冷门宝藏韩漫，分类索引做得很好，找漫效率比以前高太多了。',
    likes: 96,
  },
  {
    avatar: 'L',
    name: '夜读侠',
    time: '8小时前',
    content: '更新速度是真快，基本同步韩国那边，追更党的福音。界面也很清爽，阅读体验舒适。',
    likes: 74,
  },
  {
    avatar: 'X',
    name: '小透明',
    time: '12小时前',
    content: '完结作品区真的太香了，一口气补完了好几部经典，周末就这么愉快地度过了。',
    likes: 53,
  },
  {
    avatar: 'F',
    name: '风行者',
    time: '1天前',
    content: '作为老漫迷，韩漫网的收录量真的感人，好多绝版老漫都能找到，收藏了收藏了！',
    likes: 41,
  },
];

export const faqs = [
  {
    q: '韩漫网上的漫画可以免费看吗？',
    a: '韩漫网提供大量韩漫作品的免费在线阅读服务，您可以通过下拉式阅读模式畅享热门连载与完结经典，无需注册即可开始阅读。部分独家内容可能需要登录后查看。',
  },
  {
    q: '更新频率是怎样的？',
    a: '我们每日同步更新超过200话最新韩漫内容，热门作品基本与韩国同步更新。您可以通过首页更新快讯或关注作品页面获取最新章节信息。',
  },
  {
    q: '如何在手机上阅读韩漫？',
    a: '韩漫网完美适配移动端浏览器，直接使用手机浏览器访问即可享受与桌面端一致的阅读体验。下拉式阅读在手机上尤其流畅，随时随地追更。',
  },
  {
    q: '我想推荐冷门漫画可以吗？',
    a: '当然可以！我们欢迎所有漫迷通过联系我们页面提交作品推荐。优秀的推荐会被收录到冷门佳作发掘等专题中，让更多人看到你喜欢的作品。',
  },
];

export const carouselItems = [
  {
    title: '韩漫入门必读指南',
    desc: '从零开始了解韩漫文化，精选十部代表作品，带你快速融入韩漫的精彩世界。',
    tag: '新手向',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20beginner%20guide%20illustration%2C%20warm%20welcoming%20atmosphere%2C%20open%20book%20with%20colorful%20comic%20panels%2C%20friendly%20and%20inviting%20design%20with%20clean%20background&width=600&height=400&seq=carousel-01&orientation=landscape',
  },
  {
    title: '2026上半年韩漫销量TOP20',
    desc: '权威数据盘点，看看哪些韩漫作品在今年上半年拿下了最亮眼的销量成绩。',
    tag: '盘点',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20bestseller%20ranking%20illustration%2C%20premium%20golden%20trophy%20vibe%2C%20top%20sales%20charts%2C%20elegant%20clean%20layout%20with%20warm%20gradient%20background&width=600&height=400&seq=carousel-02&orientation=landscape',
  },
  {
    title: '画风华丽的韩漫推荐',
    desc: '精美画风是韩漫的一大特色，我们精选了画面最惊艳的韩漫作品，每一帧都是壁纸。',
    tag: '画风',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20webtoon%20art%20style%20showcase%2C%20stunning%20visuals%20with%20rich%20warm%20colors%2C%20artistic%20masterpiece%20vibe%2C%20gallery%20quality%20layout%20with%20elegant%20background&width=600&height=400&seq=carousel-03&orientation=landscape',
  },
  {
    title: '那些改编成韩剧的漫画',
    desc: '从漫画到荧幕，盘点那些被改编为热门韩剧的原作漫画，感受不同媒介的魅力。',
    tag: '改编',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20adaptation%20illustration%2C%20cinematic%20split%20screen%20comic%20to%20live%20action%2C%20dramatic%20warm%20lighting%2C%20professional%20layout%20with%20clean%20background&width=600&height=400&seq=carousel-04&orientation=landscape',
  },
  {
    title: '每周追更时间表',
    desc: '整理热门韩漫的每周更新时间，合理安排追更节奏，不错过每一部心头好的更新。',
    tag: '追更',
    image: 'https://readdy.ai/api/search-image?query=Weekly%20Korean%20webtoon%20schedule%20calendar%20illustration%2C%20organized%20timetable%20vibe%2C%20warm%20and%20cozy%20design%2C%20clean%20layout%20with%20soft%20gradient%20background&width=600&height=400&seq=carousel-05&orientation=landscape',
  },
];

export const indexItems = [
  { name: '热血格斗', count: '1,280部', icon: 'ri-sword-line' },
  { name: '恋爱甜漫', count: '2,150部', icon: 'ri-heart-line' },
  { name: '奇幻冒险', count: '1,890部', icon: 'ri-compass-3-line' },
  { name: '宫廷权谋', count: '960部', icon: 'ri-vip-crown-line' },
  { name: '穿越重生', count: '1,450部', icon: 'ri-loop-left-line' },
  { name: '都市言情', count: '1,720部', icon: 'ri-building-line' },
  { name: '悬疑推理', count: '680部', icon: 'ri-search-eye-line' },
  { name: '修仙玄幻', count: '1,100部', icon: 'ri-moon-line' },
];

export const mediaItems = [
  {
    title: '剑尊归来·宿命之战',
    views: '128万',
    tag: '热门',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20vertical%20poster%20style%20martial%20arts%20epic%20battle%2C%20dramatic%20warm%20colors%2C%20cinematic%20portrait%20composition%2C%20clean%20professional%20design&width=400&height=560&seq=media-01&orientation=portrait',
  },
  {
    title: '我独自升级·终章',
    views: '256万',
    tag: '完结',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20vertical%20poster%20style%20solo%20hunter%20finale%2C%20dark%20warm%20atmosphere%2C%20cinematic%20portrait%20composition%2C%20clean%20professional%20design&width=400&height=560&seq=media-02&orientation=portrait',
  },
  {
    title: '全知读者视角·新篇',
    views: '98万',
    tag: '连载',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20vertical%20poster%20style%20mysterious%20reader%20theme%2C%20warm%20amber%20lighting%2C%20cinematic%20portrait%20composition%2C%20clean%20professional%20design&width=400&height=560&seq=media-03&orientation=portrait',
  },
  {
    title: '反派大小姐·宫廷篇',
    views: '76万',
    tag: '连载',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20vertical%20poster%20style%20villainess%20noblewoman%2C%20elegant%20warm%20romantic%20tone%2C%20cinematic%20portrait%20composition%2C%20clean%20professional%20design&width=400&height=560&seq=media-04&orientation=portrait',
  },
  {
    title: '重生之都市修仙·飞升',
    views: '54万',
    tag: '热门',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20vertical%20poster%20style%20cultivation%20urban%20fantasy%2C%20warm%20mystical%20glow%2C%20cinematic%20portrait%20composition%2C%20clean%20professional%20design&width=400&height=560&seq=media-05&orientation=portrait',
  },
];

export const aboutInfo = {
  title: '关于韩漫网',
  content: '韩漫网是专注于韩国漫画内容聚合与阅读的综合性韩漫网站。我们致力于为广大漫迷提供最全面的漫画韩漫网址导航、最快的更新速度以及最优质的阅读体验。从热血战斗到甜蜜恋爱，从经典完结到最新连载，韩漫网官网首页入口始终是您免费看韩漫的最佳选择。平台收录超过一万两千部韩漫作品，每日更新超过两百话内容，已陪伴超过百万漫迷度过无数个追更日夜。',
};

export const appInfo = {
  title: '随时随地看韩漫',
  desc: '韩漫网完美适配手机浏览器，无需下载安装，打开浏览器输入韩漫网地址即可畅享全部功能。下拉式阅读在移动端体验更加流畅自然，让你的碎片时间充满精彩故事。',
  features: ['无需下载APP', '浏览器即开即看', '完美适配手机屏幕', '下拉式流畅阅读', '书架收藏同步'],
};